import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const SwapIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8.5 9.00003L15.5 9.00003M15.5 9.00003L13.5 7M15.5 9.00003L13.5 11" />
      <path d="M10.5 17L8.5 15M8.5 15L10.5 13M8.5 15L15.5 15" />
    </SvgIcon>
  )
}
